import dynamic from 'next/dynamic';
// import FixHeader from './components/FixHeader';
// import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import AMZMemberDay from 'elem/compCommon/PillarPageActivities/AMZMemberDay';
// import BlackFriday from '@elem/compCommon/PillarPageActivities/BlackFriday';
import { useRouter } from 'next/router';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useState, useEffect } from 'react';
// import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexDynamic'), { ssr: true });
export default function WholeHomeH5() {
    const { locale = 'us' } = useRouter();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`whole-home ${css['whole-home']}`}>
            <A />
            <AMZMemberDay />
            <IndexDynamic />
            {locale === 'us' && isClient && <QuoteWinFloat callback={quoteCallback} />}
            {locale === 'us' && isClient && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
}
